import {
  atom,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { localStorageEffect } from "utils/localStorageUtils";

const localStorageKey = "drawer";

const drawerState = atom({
  key: "DrawerState",
  default: true,
  effects: [localStorageEffect(localStorageKey)],
});

export const useDrawerState = () => useRecoilState(drawerState);
export const useSetDrawerState = () => useSetRecoilState(drawerState);
export const useResetDrawerState = () => useResetRecoilState(drawerState);
